import styled from 'styled-components'
import ClassNavigation from 'class/class-navigation'
import ClassFeatures from 'class/class-features'
import ClassDescription from 'class/class-description'
import { Typography } from 'common/typography'
import { useLesson, useLessons } from 'querys/lesson'
import { TransparentButton } from 'common/button'
import { ArrowBottom } from 'components/icons/arrow'
import getLessonNumber from 'utils/get-lessson-number'

const OpenLessons = styled(TransparentButton)`
  position: absolute;
  padding: 1rem;
  right: 0;
  top: -0.6rem;
  @media(min-width: 1024px) {
    display: none;
  }
`

const LessonContentStyled = styled.div`
  display: ${({ show }) => (show ? 'block' : 'none')};
  color: var(--white);
  .wrapper {
    padding: 16px 16px 0 16px;
  }
  .lesson-number {
    color: var(--turquoise);
    display: block;
    margin-right: 8px;
  }
  .lesson-info {
    position: relative;
  }
  h1 {
    display: flex;
    max-width: calc(100% - 46px);
  }
  @media(min-width: 1024px) {
    display: block;
    .lesson-info {
      display: grid;
      grid-template-areas: "title features navigation";
      grid-template-columns: 1fr min-content min-content;
      column-gap: 1rem;
      align-items: center;
    }
    .wrapper {
      padding: 16px 24px 0;
    }
  }
`

function LessonInfo({ setLessonsOpen, show }) {
  const {
    data: { title, content },
  } = useLesson()
  const {
    data,
  } = useLessons()
  return (
    <LessonContentStyled show={show}>
      <div className="wrapper">
        <div className="lesson-info">
          <Typography id="lesson-title" as="h1" small="regularBold" large="headline6" color="var(--baseNeutral)">
            <span className="lesson-number">
              {getLessonNumber(data, title)}
              {'.'}
            </span>
            {title}
          </Typography>
          <OpenLessons onClick={() => setLessonsOpen(true)}>
            <ArrowBottom color="var(--secondary)" width="14px" height="9px" />
          </OpenLessons>
          <ClassNavigation />
          <ClassFeatures />
        </div>
        {
          content?.blocks ? <ClassDescription content={content?.blocks} /> : null
        }

      </div>
    </LessonContentStyled>
  )
}

export default LessonInfo
